import { IPaginationParameters, NetworkResponse } from "~/app/type/common";
import { requestREST } from "~/client/http/CommonHTTP";
import {
  IZDSetComplianceParams,
  IZDUpdateCommentParams,
  IZDUpdateFilesParams,
} from "~/entity/ZD/model/schema";

const ZDServiceMap = {
  positions: "/zdpersonal/positions",
  compliance: "/zdpersonal/compliance",
  comment: "/zdpersonal/comment",
  check: "/zdpersonal/check",
  files: "/zdpersonal/files",
};

export class ZDService {
  static _routes = ZDServiceMap;
  static GET = {
    getZDPositionsList: (
      params: IPaginationParameters & { dealerId: string }
    ): NetworkResponse<{ fileHash: string }> => {
      return requestREST.get(ZDServiceMap.positions, {
        params,
      });
    },
  };
  static POST = {
    setCompliance: (data: IZDSetComplianceParams) => {
      return requestREST.post(ZDServiceMap.compliance, data);
    },
    startCheck: () => {
      return requestREST.post(ZDServiceMap.check);
    },
  };
  static PUT = {
    updateFiles: (data: IZDUpdateFilesParams) => {
      return requestREST.put(ZDServiceMap.files, data);
    },

    updateComment: (data: IZDUpdateCommentParams) => {
      return requestREST.put(ZDServiceMap.comment, data);
    },
  };
}
